export const projeler = {
  title: 'Projeler',
  titleEN: 'Projects',
  description: 'Onedio.com\'da yayınlanan liste ve quiz içeriklerinden farklı olarak, teknik, tasarım ve content ekiplerinin çalışması sonucu oluşturulan, temel amacı marka ve kampanya bilinirliği arttırmak olan kullanıcı etkileşimli kurgulardır.',
  descriptionEN: 'Unlike the list and quiz content published on Onedio.com, these are user-interactive scenarios created through the collaboration of technical, design, and content teams, with the primary aim of increasing brand and campaign awareness.',
  tabs: [
    {
      id: 1,
      title: 'Content Interaction Projects',
      sliderPerView: 3,
      width: '100%',
      slides: [
        {
          id: 1,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/cefa5752a064e8ef82b342dc7a9e9a7f3524aa119a743c357f94153f98f7b66a.png',
          url: 'https://legacy.onedio.com/haber/og-rendig-inizde-sizi-uludag-in-zirvesine-cikartacak-suyla-i-lgili-10-i-lginc-bilgi-716890',
          category: 'Erikli',
        },
        {
          id: 2,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/bf50270b2a1b4feeee358913cb583f62842862cbe90d78887b86422c32bc72f7.png',
          url: 'https://onedio.com/haber/dunyanin-en-zor-ikilisi-ezgi-ve-kivanc-i-tavlayabilecek-misin-706839',
          category: 'Axe Black Night'
        },
        {
          id: 3,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/bb3575fa93533092efdbb2f32337258eeac3403d300fcf490846a4145cdd837c.png',
          url: 'https://editor.onedio.com/haber/hayattaki-kucuk-detaylarin-buyuk-farklar-yaratabileceginin-10-kaniti-969954',
          category: 'Samsung'
        },
        {
          id: 4,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/3e572da4e7c986ae8293ba3f66f23004bdae9e833a9beba2e1975431b6bcefe5.png',
          url: 'https://onedio.com/haber/bu-senin-hikayen-secimlerine-gore-senin-hikayeni-birlikte-yaziyoruz-1002288',
          category: 'Pandora'
        },
        {
          id: 5,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/1ff74a6da1cbaf7337bebaa8e7cfc8f0f107d001e1dbf591c930070ea96ecf81.png',
          url: 'https://www.figma.com/proto/pd1ihpN1U7TbqxCfsJGJhL?page-id=1%3A820&node-id=1%3A820&scaling=min-zoom&starting-point-node-id=32%3A739&show-proto-sidebar=1',
          category: 'Simple'
        },
        {
          id: 6,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/577dca10f23e7eaa75e1ab6a983c93631a0361ca0e25d1d489940bfebb99e9b8.png',
          url: 'https://onedio.com/ulker-mini',
          category: 'Ülker Mini'
        },
        {
          id: 7,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/0fb2e560eae1b27d016af2ef960d01991fd50aa72a1c4b65cef6afa7b7d7c17b.png',
          url: 'https://onedio.com/haber/kisiye-ozel-arkadaslik-testi-arkadaslarin-seni-ne-kadar-iyi-taniyor-1012250',
          category: 'Ülker Napoliten'
        }
      ]
    },
    {
      id: 2,
      title: 'Rich Media',
      sliderPerView: 3,
      width: '100%',
      slides: [
        {
          id: 1,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/612b7e5e232a2ee7764fc140f8cc8ddcbbd2e1483151b84511b3ecd347c4fa4a.png',
          url: 'https://onedio.com/?google_preview=dQaZtoP5FA0Yss_9vwYwsuuyxwaIAYCAgJC0hPazdw&iu=21814681&gdfp_req=1&lineItemId=6791626240&creativeId=138493299602',
          category: 'Heinz'
        },
        {
          id: 2,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/9ccaf0e3804c80eab64b51704fc9a6610d377319aca481f9b521f507b7937b5b.png',
          url: 'https://onedio.com/?google_preview=ucJcnI76VbwYwvHsywYwwo2i0waIAYCAgJDqotyezQE&iu=21814681&gdfp_req=1&lineItemId=6971252056&creativeId=138514730078',
          category: 'QNB Finansbank'
        },
        // {
        //   id: 3,
        //   name: '',
        //   image: 'https://srv-cdn.onedio.com/store/d916cb14bc6082c49fbc6778759038b49e226ced1b720ffbed98773fd40e3cf2.png',
        //   url: 'https://varnishbb.onedio.com/haber/verdigin-cevaplara-gore-anksiyete-seviyeni-soyluyoruz-1216705?google_preview=XOxmwftkT1cY-bWEsQYw-dG5uAaIAYCAgOC9ha2LyAE&iu=21814681&gdfp_req=1&lineItemId=4467919885&creativeId=138214908733',
        //   category: 'Stranger Things'
        // },
        {
          id: 4,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/a617046c392bfee328e8623ff8acc6ead75eb5c9ee5031a9a4bf598d35450394.png',
          url: 'https://bit.ly/akbankwings-interactive-interscroller-sunum',
          category: 'Akbank'
        },
        {
          id: 5,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/75e3b8f877ae295c47b6a1e8ca9ae58aacdc508b3d4618cd474bdc56f10d75e5.png',
          url: 'https://bit.ly/netflix-terim-mobile-app-takeover-sunum',
          category: 'Netflix Terim'
        },
        {
          id: 6,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/e9c5b45adc2612d23091113d05d7fef692489b03db1ceb67869a84f863a0ecb0.png',
          url: 'https://onedio.com/?google_preview=jzeq999xprwYrKHXxAYwrL2MzAaIAYCAgJC89p2CBA&iu=21814681&gdfp_req=1&lineItemId=6190936288&creativeId=138418230515',
          category: 'Karaca'
        },
        {
          id: 7,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/0fde6907d9fbfbfbe8d9223a6d92d8650900b3f6271a14912bfb551dd96fbfe2.png',
          url: 'https://onedio.com/?google_preview=rmIcyndIYwYYjf-dwAYwjZvTxwaIAYCAgJC0yeqKvwE&iu=21814681&gdfp_req=1&lineItemId=6971252056&creativeId=138514544523',
          category: 'Eti Canga'
        },
        {
          id: 8,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/644af99cc005901bd23e1104c6cc9c772afed4218a13ff3dba2a70afd85366f3.png',
          url: 'https://bit.ly/hyundai-i20-speed-takeover-sunum',
          category: 'Hyundai i20'
        },
        {
          id: 9,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/ad7b85f845cde8209f445f561f4557f7c0a68e2cb3884fd39c8c22e0d005b5c0.png',
          url: 'https://onedio.com/haber/netflix-thewitcher-takeover-892048',
          category: 'The Witcher'
        }
      ]
    },
    {
      id: 3,
      title: 'Technology Based Special Project',
      sliderPerView: 3,
      width: '100%',
      slides: [
        {
          id: 1,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/29e08cc85843e8457bb176710f7dd0aac62f81e31f39705374bc607ea825647a.png',
          url: 'https://vimeo.com/604901082/deaf85b9ac',
          category: 'Volvo Charge'
        },
        {
          id: 2,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/a28b212beac3ed6709a652b4015154ee3cd8ecb34e308c2130fb4e3345c6853d.png',
          url: 'https://vimeo.com/387641614/df06fe96c1',
          category: 'Toyota'
        }
      ]
    },
    {
      id: 4,
      title: 'Award Winning Projects',
      sliderPerView: 3,
      width: '100%',
      slides: [
        {
          id: 1,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/967707d4d098b1acac2d61f7b38c861a9048d5311f173f8f9162f8050935c8d6.png',
          url: 'https://vimeo.com/204874033/d894dec824',
          category: 'Sprite - Mixx'
        },
        {
          id: 2,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/80e7ef0284151e45a0a87c1adea2047ee2d38ab032d89d1bca89467599f91fc4.png',
          url: 'https://vimeo.com/208805325',
          category: 'Samsung - Mixx/Felis'
        },
        {
          id: 3,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/a28da1191adfa7c5e4f8c46146937930bb6fbec98682000ee2ff2843ba08b649.png',
          url: 'https://vimeo.com/345861583',
          category: 'Huawei - Kristal Elma/Felis/MMA Smarties'
        },
        {
          id: 4,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/5a3b5900327eb31a7cff2f246bbaa21a4c3151055b0cfe9f8c8d0cf276f6be9d.png',
          url: 'https://vimeo.com/579855720/674f49063a',
          category: 'QNB Finansbank - MMA Smarties'
        },
        {
          id: 5,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/cb8285854ed82d8d4439578824dd00ffd6b2af675af269b8e3a079b986bf4e84.png',
          url: 'https://vimeo.com/777947852?embedded=true&source=video_title&owner=14713612',
          category: 'Trendyol - MMA Smarties'
        },
        {
          id: 6,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/b918f49689f42eb105da98bf43c1da66ed456afcb1d51f715b341e086ff7a568.png',
          url: 'https://onedio.com/hareketsozlugu',
          category: 'Rexona - Mixx'
        },
        {
          id: 7,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/29a8fbe64eac530980d7b5123314113febc157d555f8d470f678c13a5a2a68d8.png',
          url: 'https://vimeo.com/253251055/11acb091af',
          category: 'Akbank - Mixx Global'
        }
      ]
    }
  ],
  egTabs: [
    {
      id: 1,
      title: 'Content Interaction Projects',
      sliderPerView: 3,
      width: '100%',
      slides: [
        {
          id: 1,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/cefa5752a064e8ef82b342dc7a9e9a7f3524aa119a743c357f94153f98f7b66a.png',
          url: 'https://legacy.onedio.com/haber/og-rendig-inizde-sizi-uludag-in-zirvesine-cikartacak-suyla-i-lgili-10-i-lginc-bilgi-716890',
          category: 'Erikli',
        },
        {
          id: 2,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/bf50270b2a1b4feeee358913cb583f62842862cbe90d78887b86422c32bc72f7.png',
          url: 'https://onedio.com/haber/dunyanin-en-zor-ikilisi-ezgi-ve-kivanc-i-tavlayabilecek-misin-706839',
          category: 'Axe Black Night'
        },
        {
          id: 3,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/bb3575fa93533092efdbb2f32337258eeac3403d300fcf490846a4145cdd837c.png',
          url: 'https://editor.onedio.com/haber/hayattaki-kucuk-detaylarin-buyuk-farklar-yaratabileceginin-10-kaniti-969954',
          category: 'Samsung'
        },
        {
          id: 4,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/3e572da4e7c986ae8293ba3f66f23004bdae9e833a9beba2e1975431b6bcefe5.png',
          url: 'https://onedio.com/haber/bu-senin-hikayen-secimlerine-gore-senin-hikayeni-birlikte-yaziyoruz-1002288',
          category: 'Pandora'
        },
        {
          id: 5,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/1ff74a6da1cbaf7337bebaa8e7cfc8f0f107d001e1dbf591c930070ea96ecf81.png',
          url: 'https://www.figma.com/proto/pd1ihpN1U7TbqxCfsJGJhL?page-id=1%3A820&node-id=1%3A820&scaling=min-zoom&starting-point-node-id=32%3A739&show-proto-sidebar=1',
          category: 'Simple'
        },
        {
          id: 6,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/577dca10f23e7eaa75e1ab6a983c93631a0361ca0e25d1d489940bfebb99e9b8.png',
          url: 'https://onedio.com/ulker-mini',
          category: 'Ülker Mini'
        },
        {
          id: 7,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/0fb2e560eae1b27d016af2ef960d01991fd50aa72a1c4b65cef6afa7b7d7c17b.png',
          url: 'https://onedio.com/haber/kisiye-ozel-arkadaslik-testi-arkadaslarin-seni-ne-kadar-iyi-taniyor-1012250',
          category: 'Ülker Napoliten'
        }
      ]
    },
    {
      id: 2,
      title: 'Rich Media',
      sliderPerView: 3,
      width: '100%',
      slides: [
        {
          id: 1,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/612b7e5e232a2ee7764fc140f8cc8ddcbbd2e1483151b84511b3ecd347c4fa4a.png',
          url: 'https://onedio.com/?google_preview=dQaZtoP5FA0Yss_9vwYwsuuyxwaIAYCAgJC0hPazdw&iu=21814681&gdfp_req=1&lineItemId=6791626240&creativeId=138493299602',
          category: 'Heinz'
        },
        {
          id: 2,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/9ccaf0e3804c80eab64b51704fc9a6610d377319aca481f9b521f507b7937b5b.png',
          url: 'https://onedio.com/?google_preview=ucJcnI76VbwYwvHsywYwwo2i0waIAYCAgJDqotyezQE&iu=21814681&gdfp_req=1&lineItemId=6971252056&creativeId=138514730078',
          category: 'QNB Finansbank'
        },
        // {
        //   id: 3,
        //   name: '',
        //   image: 'https://srv-cdn.onedio.com/store/d916cb14bc6082c49fbc6778759038b49e226ced1b720ffbed98773fd40e3cf2.png',
        //   url: 'https://varnishbb.onedio.com/haber/verdigin-cevaplara-gore-anksiyete-seviyeni-soyluyoruz-1216705?google_preview=XOxmwftkT1cY-bWEsQYw-dG5uAaIAYCAgOC9ha2LyAE&iu=21814681&gdfp_req=1&lineItemId=4467919885&creativeId=138214908733',
        //   category: 'Stranger Things'
        // },
        {
          id: 4,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/a617046c392bfee328e8623ff8acc6ead75eb5c9ee5031a9a4bf598d35450394.png',
          url: 'https://bit.ly/akbankwings-interactive-interscroller-sunum',
          category: 'Akbank'
        },
        {
          id: 5,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/75e3b8f877ae295c47b6a1e8ca9ae58aacdc508b3d4618cd474bdc56f10d75e5.png',
          url: 'https://bit.ly/netflix-terim-mobile-app-takeover-sunum',
          category: 'Netflix Terim'
        },
        {
          id: 6,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/e9c5b45adc2612d23091113d05d7fef692489b03db1ceb67869a84f863a0ecb0.png',
          url: 'https://onedio.com/?google_preview=jzeq999xprwYrKHXxAYwrL2MzAaIAYCAgJC89p2CBA&iu=21814681&gdfp_req=1&lineItemId=6190936288&creativeId=138418230515',
          category: 'Karaca'
        },
        {
          id: 7,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/0fde6907d9fbfbfbe8d9223a6d92d8650900b3f6271a14912bfb551dd96fbfe2.png',
          url: 'https://onedio.com/?google_preview=rmIcyndIYwYYjf-dwAYwjZvTxwaIAYCAgJC0yeqKvwE&iu=21814681&gdfp_req=1&lineItemId=6971252056&creativeId=138514544523',
          category: 'Eti Canga'
        },
        {
          id: 8,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/644af99cc005901bd23e1104c6cc9c772afed4218a13ff3dba2a70afd85366f3.png',
          url: 'https://bit.ly/hyundai-i20-speed-takeover-sunum',
          category: 'Hyundai i20'
        },
        {
          id: 9,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/ad7b85f845cde8209f445f561f4557f7c0a68e2cb3884fd39c8c22e0d005b5c0.png',
          url: 'https://onedio.com/haber/netflix-thewitcher-takeover-892048',
          category: 'The Witcher'
        }
      ]
    },
    {
      id: 3,
      title: 'Technology Based Special Project',
      sliderPerView: 3,
      width: '100%',
      slides: [
        {
          id: 1,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/29e08cc85843e8457bb176710f7dd0aac62f81e31f39705374bc607ea825647a.png',
          url: 'https://vimeo.com/604901082/deaf85b9ac',
          category: 'Volvo Charge'
        },
        {
          id: 2,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/a28b212beac3ed6709a652b4015154ee3cd8ecb34e308c2130fb4e3345c6853d.png',
          url: 'https://vimeo.com/387641614/df06fe96c1',
          category: 'Toyota'
        }
      ]
    },
    {
      id: 4,
      title: 'Award Winning Projects',
      sliderPerView: 3,
      width: '100%',
      slides: [
        {
          id: 1,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/967707d4d098b1acac2d61f7b38c861a9048d5311f173f8f9162f8050935c8d6.png',
          url: 'https://vimeo.com/204874033/d894dec824',
          category: 'Sprite - Mixx'
        },
        {
          id: 2,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/80e7ef0284151e45a0a87c1adea2047ee2d38ab032d89d1bca89467599f91fc4.png',
          url: 'https://vimeo.com/208805325',
          category: 'Samsung - Mixx/Felis'
        },
        {
          id: 3,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/a28da1191adfa7c5e4f8c46146937930bb6fbec98682000ee2ff2843ba08b649.png',
          url: 'https://vimeo.com/345861583',
          category: 'Huawei - Kristal Elma/Felis/MMA Smarties'
        },
        {
          id: 4,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/5a3b5900327eb31a7cff2f246bbaa21a4c3151055b0cfe9f8c8d0cf276f6be9d.png',
          url: 'https://vimeo.com/579855720/674f49063a',
          category: 'QNB Finansbank - MMA Smarties'
        },
        {
          id: 5,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/cb8285854ed82d8d4439578824dd00ffd6b2af675af269b8e3a079b986bf4e84.png',
          url: 'https://vimeo.com/777947852?embedded=true&source=video_title&owner=14713612',
          category: 'Trendyol - MMA Smarties'
        },
        {
          id: 6,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/b918f49689f42eb105da98bf43c1da66ed456afcb1d51f715b341e086ff7a568.png',
          url: 'https://onedio.com/hareketsozlugu',
          category: 'Rexona - Mixx'
        },
        {
          id: 7,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/29a8fbe64eac530980d7b5123314113febc157d555f8d470f678c13a5a2a68d8.png',
          url: 'https://vimeo.com/253251055/11acb091af',
          category: 'Akbank - Mixx Global'
        }
      ]
    }
  ]
}